var map = {
	"./DataScience/blog.json": 60855,
	"./ai/blog.json": 25115,
	"./android/blog.json": 68946,
	"./arvr/blog.json": 41321,
	"./backend/blog.json": 1332,
	"./bioinformatics/blog.json": 13615,
	"./biotech/blog.json": 16192,
	"./blockchain/blog.json": 28359,
	"./creativedesign/blog.json": 62286,
	"./cybersecurity/blog.json": 95597,
	"./database/blog.json": 2123,
	"./devops/blog.json": 81507,
	"./edgecomputing/blog.json": 62961,
	"./embedded-system/blog.json": 87644,
	"./foss/blog.json": 54165,
	"./frontend/blog.json": 12409,
	"./generative-ai/blog.json": 39417,
	"./ios/blog.json": 15481,
	"./iot/blog.json": 19207,
	"./marketing/blog.json": 15188,
	"./photonics/blog.json": 60366,
	"./pm/blog.json": 19307,
	"./qa/blog.json": 50176,
	"./quantum-computing/blog.json": 1948,
	"./robotics-automation/blog.json": 30067,
	"./space-technology/blog.json": 94106,
	"./uiux/blog.json": 25726,
	"./web/blog.json": 96510
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6474;
module.exports = webpackAsyncContext;